module.exports = __webpack_public_path__ + "img/castalis_slim_gluten_free.bee7f083.jpg";